import React, { useEffect, useState } from 'react';
import { Col, Form, FormInstance, Grid, Message, Row, Schema } from "rsuite";
import { FirstCountryVisitAchievementType, UpsertFirstCountryVisitAchievementType } from '@/models/achievement.model';
import { getCountriesLookup } from '@/services/country.service';
import FetchingSelect from '@/components/FetchingSelect';

const modelSchema = Schema.Model<UpsertFirstCountryVisitAchievementType>({
  countryId: Schema.Types.NumberType().isRequired('This field is required.'),
});
const emptyModel: UpsertFirstCountryVisitAchievementType = {
  countryId: undefined,
};

interface FirstCountryVisitFormProps{
  formObject?: FirstCountryVisitAchievementType;
  onFormChange: (formValue: any) => void;
  formRef: React.Ref<FormInstance<Record<string, any>>>;
  loading: number;
}

const FirstCountryVisitForm: React.FC<FirstCountryVisitFormProps> = ({ formObject, onFormChange, formRef, loading }) => {
  const [formValue, setFormValue] = useState<UpsertFirstCountryVisitAchievementType>(emptyModel);
  
  useEffect(() => {
    if (formObject) {
      setFormValue(formObject);
    } else {
      setFormValue(emptyModel);
    }
  }, [formObject]);

  useEffect(() => {
    onFormChange(formValue);
  }, [formValue]);
  
  return (
    <Form name='upsert-first-country' fluid
        ref={formRef}
        formValue={formValue}
        model={modelSchema}
        disabled={!!loading}
    >    
      <Grid w='100%' fluid>
        <Row>
          <Col span={{xs:24, lg:6}}>
            <Form.Group controlId="CountryId">
              <Form.Label>Country</Form.Label>
              <Form.Control name="CountryId" accepter={FetchingSelect} block
                fetchData={(text, page) => getCountriesLookup(text, page)} 
                placeholder="Select a Country"
                value={formValue.countryId}
                onChange={val=> setFormValue(pre => ({...pre, countryId: val}))}
              />   
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Message showIcon type="info">
            ...
          </Message>
        </Row>         
      </Grid>
    </Form>
  );
};

export default FirstCountryVisitForm;